import { render } from "./OptionNav.vue?vue&type=template&id=4d985ce6"
import script from "./OptionNav.vue?vue&type=script&lang=js"
export * from "./OptionNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__